module.exports = __webpack_public_path__ + "media/images/dot-mask-f72c9a769cee533faef0f3f7c851485f.svg";